import hash from 'object-hash';

export const Endpoint = () => `/api/ui/audit/sbom`;
export const QueryKey = (payload: Payload) =>
    ['ui', 'audit', 'sbom', hash(payload, { algorithm: 'md5', unorderedArrays: true })] as const;
export type Payload = File;

export type Response = {
    package: string;
    version: string;
    fixedVersion: string;
    scopes: string[];
    applicableAdvisories: {
        id: string;
        type: string;
        match: string;
        title: string;
        description: string;
        aiDescription?: string;
        published: Date;
        epss?: {
            cve: string;
            epss: number;
            percentile: number;
            date: Date;
        }[];
        aiScore?: {
            value: number;
            uncertainty: number;
        };
        metrics?: {
            cvss?: {
                vector: string;
                score: number;
                version: string;
                severity: string;
            };
        };
        exploitation?: {
            wildExploited?: boolean;
        };
        enchantments?: {
            tags?: string[];
        };
        webApplicability?: boolean;
        references?: string[];
        exploits?: object[];
    }[];
}[];
